import React, { useState, useEffect } from "react";
import { useForm, SubmitHandler } from "react-hook-form";
import { motion } from "framer-motion";
import { database } from "../../../../appWrite";
import { useAppDispatch } from "../../../../redux/hooks";
import { fetchItems } from "../../../../redux/slices/AllItemSlice";

interface Product {
  title: string;
  description: string;
}

interface ProductEditModalProps {
  isOpen: boolean;
  onClose: () => void;
  product: any; // The testimonial to edit
}

const ProductEditModal: React.FC<ProductEditModalProps> = ({
  isOpen,
  onClose,
  product,
}) => {
  const dispatch = useAppDispatch();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<Product>();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (product) {
      reset({
        title: product.title,
        description: product.description,
      });
    }
  }, [product, reset]);

  const onSubmit: SubmitHandler<Product> = async (data) => {
    setLoading(true);
    try {
      // Update Testimonial
      await database.updateDocument(
        "67ce8a4a0032e13c6368",
        "67dd738c000eb29fbaaf",
        product.id,
        {
          title: data.title,
          description: data.description,
        }
      );

      dispatch(fetchItems());
      onClose();
    } catch (error) {
      console.error("Error updating testimonial:", error);
    }
    setLoading(false);
  };

  if (!isOpen) return null;

  const input =
    "w-full px-3 py-2 border rounded-md focus:outline-none focus:ring focus:ring-primary";
  const btnPrimary =
    "px-4 py-2 bg-primary text-white rounded-md hover:bg-opacity-90";
  const btnSecondary =
    "px-4 py-2 bg-gray-200 text-black rounded-md hover:bg-gray-300";

  return (
    <motion.div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -20 }}
        className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full mx-3 md:mx-0"
      >
        <h2 className="text-xl font-bold mb-4">Edit Product</h2>
        <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
          <input
            {...register("title", { required: true })}
            placeholder="Title"
            className={input}
          />
          {errors.title && (
            <p className="text-red-500 text-sm">Title is required</p>
          )}

          <textarea
            rows={6}
            {...register("description", { required: true })}
            placeholder="Description"
            className={input}
          ></textarea>
          {errors.description && (
            <p className="text-red-500 text-sm">Description is required</p>
          )}

          <div className="flex justify-end gap-2">
            <button type="button" onClick={onClose} className={btnSecondary}>
              Cancel
            </button>
            <button type="submit" className={btnPrimary} disabled={loading}>
              {loading ? "Saving..." : "Update"}
            </button>
          </div>
        </form>
      </motion.div>
    </motion.div>
  );
};

export default ProductEditModal;
